export default class TabModel {
  constructor(id, index, label, ariaControl, disabled = false) {
    this.id = id;
    this.index = index;
    this.label = label;
    this.ariaControl = ariaControl;
    this.disabled = disabled;
  }
}
